class RoomManager {
    _room: any

    constructor() {
        this._room = null
    }

    setRoom(room: any) {
        this._room = room
    }

    getRoom() {
        return this._room
    }
}

const instance = new RoomManager()

export default instance
